import StreamContainer from './StreamContainer';

export default StreamContainer;
